export enum SessionKeys {
  IsUserLoggedIn = "isUserLoggedIn",
  UserId = "userId",
  UserName = "userName",
  WinUserName = "winUserName",
  UserRole = "userRole",
  Designation = "designation",
  UserDepartment = "userDepartment",
  UserObject = "userObject",
  Type = "type",
  UserIP = "userIP",
  IsLdap = "isLdap",
  RightsArray = "rightsarray",
  EditMode = "editmode",
  AllSystemRights = "allSystemRights",
  TimeDate="TimeDate",
  LastUser="lastUser",
  LastRoute="lastRoute",
  UserSignature="userSignature"
}
